import type { PublicFormState } from '@/types/publicForm'

// Verbatim from core/application/views/layouts/forms/*.php, except `throttled`,
// which has no legacy equivalent. The Record keeps every state covered.
const states: Record<Exclude<PublicFormState, 'open'>, { heading: string; body: string }> = {
    removed: {
        heading: `Form Not Found`,
        body: `Sorry, this form has either been removed or never existed in the first place.`
    },
    disabled: {
        heading: `Form Disabled`,
        body: `Sorry, this form is disabled.`
    },
    limit: {
        heading: `Form Entry Limit Reached`,
        body: `Sorry, this form cannot accept any more entries.`
    },
    failed: {
        heading: `Card Could Not Be Charged`,
        body: `Sorry, we were unable to charge this card. Please return to form and try again with a different card.`
    },
    throttled: {
        heading: `Too Many Requests`,
        body: `We have received too many requests from your IP in a short period. Please try again later.`
    }
}

export default {
    publicForm: {
        states,
        returnToForm: `Return to Form`,
        loadError: `Sorry, this form could not be loaded. Please try again.`,
        submit: `Submit`,
        confirmation: `Thank you, your response has been submitted.`,
        submitInvalid: `Some answers need attention. Please check the form and try again.`,
        submitError: `Sorry, your response could not be submitted. Please try again.`,
        validation: {
            required: `This field is required.`,
            email: `Enter a valid email address.`,
            phone: `Enter a valid phone number.`,
            zip: `Enter a valid zip or postal code.`,
            birthdate: `Enter a valid birthdate.`,
            tooLong: `This answer is too long.`,
            streetLine1: `Please add the first line of your street address, or clear the second line.`
        },
        fields: {
            firstName: `First Name`,
            lastName: `Last Name`,
            homePhone: `Home Phone`,
            mobilePhone: `Mobile Phone`,
            workPhone: `Work Phone`,
            streetAddress: `Street Address`,
            streetAddress2: `Street Address (Line 2)`,
            city: `City`,
            state: `State / Province`,
            zip: `Zip / Postal Code`,
            zipCode: `Zip Code`,
            postalCode: `Postal Code`,
            month: `Month`,
            day: `Day`,
            year: `Year`
        }
    }
}
